import { useSelector, useDispatch } from 'react-redux';

const FIELD_REQUIRED = 'Field is required.';
const NUMBER_ONLY = 'Field is required and only numbers are allowed.';
const PDF_ONLY = 'Field is required and only pdf file is allowed.';

function useExistingNumberForm({ fileUpload }) {
    const { state, stateError } = useSelector((state) => {
        return { ...state.modal };
    });
    const dispatch = useDispatch();

    const formUpload = () => {
        const aggregateNumbers =
            state?.aggregateTable
                ?.filter((v) => v.from?.length > 0 || v.to?.length > 0)
                .map((v) =>
                    v.from < v.to
                        ? String(v.from) + '-' + String(v.to)
                        : String(v.from),
                ) || [];
        const numberlist = aggregateNumbers.join(',');

        const formData = new FormData();

        const {
            carrier,
            agreeterms,
            preferredDate,
            authorizedSignerEmail,
            authorizedSignerName,
            authorizedSignerNumber,
            abn,
            preloadNumbers,
            comments,
        } = state;

        formData.append('file', fileUpload);
        formData.append('numberlist', numberlist);
        formData.append('agreeterms', agreeterms);
        formData.append('carrier', carrier);
        formData.append('authorizedSignerEmail', authorizedSignerEmail);
        formData.append('authorizedSignerName', authorizedSignerName);
        formData.append('authorizedSignerNumber', authorizedSignerNumber);
        formData.append('abn', abn);

        if (preferredDate) {
            formData.append(
                'preferredDate',
                new Date(preferredDate).toUTCString(),
            );
        }
        if (comments) {
            formData.append('comments', comments);
        }
        if (preloadNumbers) {
            formData.append('preloadNumbers', true);
        }

        return formData;
    };

    // validation function for submission of the form
    const validateOnSubmit = () => {
        const aggregateNumbers =
            state?.aggregateTable?.filter(
                (v) => v.from?.length > 0 || v.to?.length > 0,
            ) ?? [];
        const numberListError =
            aggregateNumbers.length < 1 && 'At least 1 number must be ported.';

        const newErrorState = {
            duplicates: stateError?.duplicates,
            invalidRanges: stateError?.invalidRanges,
            overlaps: stateError?.overlaps,
            numberlist: numberListError,
            bill: fileUpload?.type !== 'application/pdf' && PDF_ONLY,
            carrier:
                (!state?.carrier || state?.carrier?.length < 1) &&
                FIELD_REQUIRED,
            authorizedSignerEmail:
                (!state?.authorizedSignerEmail ||
                    state?.authorizedSignerEmail?.length < 1) &&
                FIELD_REQUIRED,
            authorizedSignerName:
                (!state?.authorizedSignerName ||
                    state?.authorizedSignerName?.length < 1) &&
                FIELD_REQUIRED,
            authorizedSignerNumber:
                (!state?.authorizedSignerNumber ||
                    state?.authorizedSignerNumber?.length < 1 ||
                    !Number(state?.authorizedSignerNumber)) &&
                NUMBER_ONLY,
        };
        dispatch({
            type: 'CHANGE_MODAL_STATE_ERROR',
            payload: newErrorState,
        });

        return !(
            newErrorState.duplicates ||
            newErrorState.invalidRanges ||
            newErrorState.overlaps ||
            newErrorState.numberlist ||
            newErrorState.bill ||
            newErrorState.carrier ||
            newErrorState.authorizedSignerName ||
            newErrorState.authorizedSignerNumber ||
            newErrorState.authorizedSignerEmail
        );
    };

    return {
        formUpload,
        validateOnSubmit,
        FIELD_REQUIRED,
        NUMBER_ONLY,
        PDF_ONLY,
    };
}

export default useExistingNumberForm;
